import dateFns from "date-fns"

export const formatDate = (date, format) => {
  return dateFns.format(date, format)
}
